export enum BoardingChannel {
  AdminScanner = 1,
  PartnerApi = 2,
  Manual = 3
}

export type BoardingOutcomeCode =
  | "boarded"
  | "valid"
  | "already_used"
  | "cancelled"
  | "not_paid"
  | "wrong_date"
  | "wrong_route"
  | "other_operator"
  | "unknown_ticket";

export type IBoardingRequest = {
  code: string;
  tripId?: number | null;
  journeyDate?: string;
  deviceRef?: string;
  scanId?: string;
  channel: BoardingChannel;
};

export type IBoardingPassenger = {
  firstName: string;
  lastName: string;
};

export type IBoardingTicketSummary = {
  bookingReference: string;
  from: string;
  to: string;
  bookedTripId: number;
  bookedDeparture: string;
  boardedTripId?: number | null;
  boardedDeparture?: string | null;
  passengerCount: number;
  passengers: IBoardingPassenger[];
};

export type IFirstBoarding = {
  at: string;
  channel: BoardingChannel;
  scannedByName?: string | null;
  bySameScanner?: boolean;
};

export type IBoardingResult = {
  outcome: number;
  outcomeCode: BoardingOutcomeCode;
  replayed?: boolean;
  ticket?: IBoardingTicketSummary | null;
  firstBoarding?: IFirstBoarding | null;
  attemptId?: number | null;
};

export type IBoardingUndo = {
  attemptId: number;
  revertedAt: string;
};

export type IBoardingTrip = {
  tripId: number;
  lineId: number;
  lineName: string;
  from: string;
  to: string;
  departureTime: string;
};

export type BoardingStatusCode = "boarded" | "not_boarded" | "no_show";

export type IDepartureCounts = {
  tripId: number;
  lineId: number;
  lineName: string;
  from: string;
  to: string;
  departure: string;
  sold: number;
  boarded: number;
  boardedFromOtherDepartures: number;
  toBoard: number;
};

export type IDepartureBooking = {
  ticketId: number;
  bookingReference: string;
  passengerCount: number;
  passengers: IBoardingPassenger[];
  status: number;
  statusCode: BoardingStatusCode;
  boardedAt?: string | null;
  bookedTripId: number;
  bookedDeparture: string;
  boardedTripId?: number | null;
};

export type IDeparturePassengers = {
  from: string;
  to: string;
  tripId: number;
  departure: string;
  bookings: IDepartureBooking[];
};

export type IBoardingHistory = {
  attemptId: number;
  scannedAt: string;
  outcome: number;
  outcomeCode: BoardingOutcomeCode;
  channelCode: "admin_scanner" | "partner_api" | "manual";
  scannedByName?: string | null;
  deviceRef?: string | null;
  journeyDate?: string | null;
  passengerCount: number;
  revertedAt?: string | null;
  revertedByName?: string | null;
};
